import Select from "react-select";
import { Redirect } from "react-router";
import React, { Component, Fragment } from "react";
import NotificationSystem from "react-notification-system";
import { Col, Form, FormGroup, Label, Input, Button, Row } from "reactstrap";
import CountryCodeSoccer from "./CountryCodeSoccer";
import PageSpinner from "../../components/PageSpinner";
import OtpInput from "react-otp-input";
import "../../styles/login.css";
import { NOTIFICATION_SYSTEM_STYLE } from "../../utils/constants";

import * as Server from "../../Server";
import * as GeneralFunctions from "../../GeneralFunctions";

class UserLogin extends Component {
  constructor(props) {
    super(props);
    this.state = {
      email: "",
      password: "",
      isemail: "",
      isphonenumber: "",
      ispassword: "",
      setmobile: "",
      setIsError: false,
      validEmail: false,
      showLoader: false,
      hideShowOtpBox: false,
      unverifiedEmailTooltip: false,
      verifiedEmailTooltip: false,
      unverifiedPhoneTooltip: false,
      verifiedPhoneTooltip: false,
      phoneOtp: "",
      phoneOtpSent: false,
      isdisabled: true,
      phoneOtpVerified: false,
      countryCode: {
        label: "🇺🇸 1",
        value: "1",
      },
    };
    this.token = null;
  }

  phoneNumberValidation = (event) => {
    event.preventDefault();
    if (event.target.value !== "") {
      document.getElementById("toDisplay").style.display = "block";
    } else if (event.target.value === "") {
      document.getElementById("toDisplay").style.display = "none";
      this.setState({ hideShowOtpBox: false });
    }
    if (event.target.value.length < 10) {
      this.setState({ hideShowOtpBox: false });
    }
    if (event.target.value.length < 11) {
      this.setState({ isphonenumber: event.target.value });
      if (event.target.value.length === 9) {
        this.setState({ isdisabled: true });
      } else if (event.target.value.length === 10) {
        this.setState({ isdisabled: false });
      }
      return true;
    }
  };

  sendOTP = async (event) => {
    event.preventDefault();
    try {
      this.setState({ showLoader: true });
      let data = {
        phone: `+${this.state.countryCode.value}${this.state.isphonenumber}`,
        userName: `${this.state.countryCode.value}${this.state.isphonenumber}`,
        hideShowOtpBox: true,
      };
      let response = await Server.chatServerRequest(
        {
          url: "api/v1/createOtp",
          method: "POST",
          data,
        },
        true
      );
      if (response) {
        this.setState({ showLoader: false });
      }
    } catch (error) {
      this.setState({ showLoader: false });
      this.notificationSystem.addNotification({
        message: error.message,
        level: "error",
      });
    }
    document.getElementById("toDisplay").style.display = "none";
    this.setState({ phoneOtp: "" });
  };

  verifyOTP = async (event) => {
    event.preventDefault();
    try {
      let data = {
        phone: `+${this.state.countryCode.value}${this.state.isphonenumber}`,
        userName: `${this.state.countryCode.value}${this.state.isphonenumber}`,
        otp: `${this.state.phoneOtp}`,
        loggedInApp: "rushsoccer",
      };
      let response = await Server.chatServerRequest({
        url: "api/v1/verifyOtp",
        method: "POST",
        data,
      });
      if (response && response.success) {
        this.setState({ showLoader: false });
        GeneralFunctions.setAuthUser(response.user);
        GeneralFunctions.setUsername(response.user.username);
        GeneralFunctions.setChatAuthorizationHeader(response.accessToken);
        GeneralFunctions.setAuthorizationHeader(response.zocialAccessToken);
        GeneralFunctions.setMarketplaceAuthorizationHeader(
          response.marketplaceAccessToken
        );
        GeneralFunctions.setPermissions("rushUser");
        this.props.history.push("/parentlist");
        window.location.reload();
      } else {
        this.setState({
          showLoader: false,
        });
        this.notificationSystem.addNotification({
          message: response.message,
          level: "error",
        });
      }
    } catch (error) {
      this.setState({ showLoader: false });
      this.notificationSystem.addNotification({
        message: error.message,
        level: "error",
      });
    }
  };

  redirectToLoginPage = () => {
    this.props.history.push("/userlogin");
  };

  render() {
    this.token = localStorage.getItem("authorization");
    return (
      <Fragment>
        {this.token ? (
          <Redirect to="/parentlist"></Redirect>
        ) : (
          <div>
            <PageSpinner showLoader={this.state.showLoader} />
            <div className="login-form">
              <Form className="form" onSubmit={this.onSubmit}>
                <Col>
                  <h2>Sign In</h2>
                </Col>
                <Col>
                  <FormGroup>
                    <Label>Username</Label>
                    <Row>
                      <Col style={{ paddingRight: "5px" }} md={3}>
                        <Select
                          options={CountryCodeSoccer.map((item, index) => ({
                            label: `${item.emoji} ${item.dialingCode}`,
                            value: item.dialingCode,
                          }))}
                          value={this.state.countryCode}
                          onChange={(result) => {
                            this.setState({ countryCode: result });
                          }}
                        />
                      </Col>
                      <Col style={{ paddingLeft: "0px" }}>
                        <Input
                          id="phoneNumber"
                          name="phoneNumber"
                          type="number"
                          value={this.state.isphonenumber || ""}
                          onChange={this.phoneNumberValidation}
                          placeholder="Enter your mobile no."
                          required
                          min="2"
                        />
                      </Col>
                    </Row>
                  </FormGroup>
                  <Button
                    id="toDisplay"
                    style={{ display: "none" }}
                    className="mt-3"
                    disabled={this.state.isdisabled}
                    onClick={(event) => {
                      this.setState({ hideShowOtpBox: true });
                      this.sendOTP(event, "phone");
                    }}
                  >
                    Send OTP
                  </Button>
                  {this.state.hideShowOtpBox === true ? (
                    <>
                      <FormGroup className="mt-3">
                        <Label>Verify Phone</Label>
                        <OtpInput
                          id="optInputBox"
                          className="otpInput d-flex justify-content-center"
                          inputStyle={{
                            color: "#17517b",
                            width: "3rem",
                            height: "3rem",
                            margin: "0 1rem",
                            fontSize: "2rem",
                            borderRadius: "4px",
                            border: "1px solid rgba(0,0,0,0.3)",
                            outlineColor: "#17517b",
                          }}
                          isInputNum={true}
                          value={this.state.phoneOtp}
                          onChange={(value) =>
                            this.setState({
                              phoneOtp: value,
                            })
                          }
                          numInputs={4}
                          separator={<span>-</span>}
                        />
                      </FormGroup>
                      <Button
                        id="verifyOtp"
                        onClick={(event) => this.verifyOTP(event, "phone")}
                      >
                        Verify OTP
                      </Button>
                      <Button
                        id="resendOtp"
                        className="ml-2"
                        onClick={(event) => this.sendOTP(event, "phone")}
                      >
                        Resend OTP
                      </Button>
                    </>
                  ) : null}
                </Col>
              </Form>
            </div>
            <NotificationSystem
              dismissible={false}
              ref={(notificationSystem) =>
                (this.notificationSystem = notificationSystem)
              }
              style={NOTIFICATION_SYSTEM_STYLE}
            />
          </div>
        )}
      </Fragment>
    );
  }
}

export default UserLogin;
